import React, { useEffect, useState, useRef } from "react";
import { PlaidLinkOptions, usePlaidLink } from "react-plaid-link";

import {
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@material-ui/core";
import Button, { ButtonProps } from "@material-ui/core/Button";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

import {
  fetchPlaidUpdateModeLinkToken,
  transferPlaidPublicToken,
} from "src/apiService/modules/plaid";

const useStyles = makeStyles((_: Theme) =>
  createStyles({
    plaidButton: {
      position: "relative",
      color: "transparent",
    },
    plaidSpinner: {
      color: "white",
      position: "absolute",
      top: "50%",
      left: "50%",
      marginTop: "-7px",
      marginLeft: "-7px",
    },
    clearDateButton: {
      alignSelf: "center",
    },
  })
);

const BaseConfig = {
  onSuccess: () => {},
  onExit: () => {},
  token: "",
};

function PlaidButton({
  config,
  ...props
}: { config: PlaidLinkOptions } & ButtonProps) {
  const { open: openPlaid } = usePlaidLink(config);

  const openPlaidLink = () => {
    openPlaid();
  };

  return (
    <Button
      onClick={openPlaidLink}
      color="primary"
      variant="contained"
      {...props}
    />
  );
}

function UpdateIntegrationAccounthDialogContent({
  onClose,
  integrationId,
}: {
  onClose: () => void;
  integrationId?: string;
}) {
  const [loading, setLoading] = useState(false);
  const [config, setConfig] = useState<PlaidLinkOptions>();
  const classes = useStyles();
  const text = `Reconnect Account`;
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!integrationId) return;
    let cancel = false;
    (async () => {
      const data = await fetchPlaidUpdateModeLinkToken(integrationId);
      if (cancel) return;
      const config: PlaidLinkOptions = {
        ...BaseConfig,
        onSuccess: async (public_token, _) => {
          setLoading(true);
          await transferPlaidPublicToken(public_token, null, {
            integration_id: data?.integration_id,
          });
          setLoading(false);
          onCloseRef.current();
        },
        onExit: (err, _) => {
          console.log(err);
          if (err) {
            console.log(`Plaid encounters an error: ${err}`);
          }
        },
        token: data?.link_token,
      };
      setConfig(config);
    })();

    return () => {
      cancel = true;
    };
  }, [integrationId]);

  return (
    <DialogContent style={{ paddingBottom: "30px" }}>
      {loading || !config ? (
        <Button
          color="primary"
          variant="contained"
          className={classes.plaidButton}
        >
          <CircularProgress size={14} className={classes.plaidSpinner} />
          {text}
        </Button>
      ) : (
        <PlaidButton config={config}>{text}</PlaidButton>
      )}
    </DialogContent>
  );
}

function UpdateIntegrationAccounthDialog({
  integrationId,
  onClose,
}: {
  integrationId?: string;
  onClose: () => void;
}) {
  return (
    <Dialog
      open={!!integrationId}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      TransitionProps={
        {
          tabIndex: "none",
        } as object
      }
    >
      <DialogTitle>Reconnect Account</DialogTitle>
      <UpdateIntegrationAccounthDialogContent
        onClose={onClose}
        integrationId={integrationId}
      />
    </Dialog>
  );
}

export default UpdateIntegrationAccounthDialog;
